<template>
  <v-card>
    <v-container fluid>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xl6 lg6 md6 sm6  hidden-xs-only>
          <v-btn style="margin:0px" flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xl6 lg6 md6 sm6 xs12 text-lg-right>
          <v-text-field
            style="padding:0px; margin:0px"
            id="searchBox"
            single-line
            v-model="searchValue"
            @keydown.enter="enter"
            placeholder="Buscar"
            append-icon="search"
            light
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider style="margin:0px"></v-divider>
    <v-card-text style="padding-top:0px">
      <v-data-table
        flat
        select-all
        v-bind:pagination.sync="pagination"
        item-key="number"
        :items="bonusCategoryPreliquidationPending"
        :headers="headers"
        class="v-table-list theme--light"
        :rows-per-page-text="$t('message.rowsByPage')"
      >
        <template slot="headers" scope="props">
          <tr class="border-buttom">
            <th width="1%" class="column"></th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon>arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" scope="props">
          <tr :active="props.selected" @click="selected = props.item.number">
            <td width="1%">
             <!--  <v-radio-group primary hide-details v-model="selected" name="rowSelector">
                <v-radio :value="props.item.number"/>
              </v-radio-group> -->
               <!-- <v-checkbox :ref="props.index" :value="props.item.number " v-model="additionalGrouped" @change="uniqueCheck(props.item.number, props.index)" primary hide-details :input-value="props.item.number"></v-checkbox> -->
               <v-checkbox hide-details  v-model="selectRow[props.index]" @change="uniqueCheck(props.item.number, props.index)"></v-checkbox>
        
            </td>
            <td class="text-xs-left cut-text">{{ nzDate(props.item.creationDate) }}</td>
            <td class="text-xs-left cut-text">{{ props.item.number }}</td>
            <td class="text-xs-left cut-text">{{ props.item.vtAgency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.apsCode }}</td>
            <td class="text-xs-left cut-text">{{ props.item.totalInvoiceVisualice | currency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.status }}</td>
          </tr>
        </template>
        <template slot="no-data">
          <div>{{$t('message.noPreliquidations')}}</div>
        </template>
        <template
          slot="pageText"
          slot-scope="props"
        >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

export default {
  computed: {
    ...mapGetters([
      "loadingBonusCategory",
      "bonusCategoryPreliquidationPending",
      "agency"
    ])
  },
  mounted() {
    this.$store.dispatch("getBonusCategoryPreliquidationPending");
  },
  methods: {
    nzDate: nzDate,
    uniqueCheck(e,index){
      let select= this.selectRow[index];
      for(let i=0;i<this.selectRow.length;i++)
      {
        if(index!=i)
        {
          this.selectRow[i]=false;
        }
      }
      if(!this.selectRow[index]){
     this.selectedValue=null;
      }else{
      this.selectedValue=e;
      }
    },
    changeSort(column) {
      this.selectedValue = null;
       this.selectRow= [],
       this.additionalGrouped=[]
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
        this.additionalGrouped[0]=this.selectedValue;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
        this.additionalGrouped[0]=this.selectedValue;
      }
    },
    refresh() {
      this.$store.dispatch("getBonusCategoryPreliquidationPending").then(()=>{
          this.selectedValue=null;
      });
    },
    enter() {
      this.$store.dispatch(
        "getBonusCategoryPreliquidationPending",
        this.searchValue
      );
    }
  },
  watch: {
    additionalGrouped(val) {
      this.$store.dispatch("updateBonusCategorySelected", val);
    },
    loadingBonusCategory(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando información, por favor espere...");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val) {
      this.$store.dispatch("getBonusCategoryPreliquidationPending");
    }
  },
  data() {
    return {
      selectedValue:null,
      selectRow:[],
      additionalGrouped: [],
      searchValue: "",
      matches: [],
      pagination: {
        sortBy: "creationDate"
      },
      selected: undefined,
      headers: [
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.date"),
          value: "creationDate",
          width: "19%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.bill"),
          value: "number",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.branch"),
          value: "vtAgency",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.agent"),
          value: "apsCode",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.generateValue"),
          value: "finalTotal",
          width: "20%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "status",
          width: "20%"
        }
      ]
    };
  }
};
</script>